<p-toast position="bottom-right"></p-toast>
<p-blockUI [blocked]="blockUI"></p-blockUI>
<div class="card" style="width:100%">
  <div class="card-body">
    <div class="row">
      <div class="field col-4">
        <label class="block" style="width:100%">&nbsp;</label>
        <p-button label="Week" icon="pi pi-palette" iconPos="left"
                  [style]="{'width':'45%'}" (onClick)="drawWeek()"></p-button> &nbsp;
        <p-button label="Month" icon="pi pi-palette" iconPos="left"
                  [style]="{'width':'45%'}" (onClick)="drawMonth()"></p-button> 
      </div>
      <div class="field col-3">
        <label class="block">From</label>
        <p-calendar [(ngModel)]="fromDate" [showTime]="true" baseZIndex="100" [style]="{'width':'100%'}" appendTo="body" showClear="true"
                    [minDate]="minSelectableDate" [maxDate]="maxSelectableDate"></p-calendar>
      </div>
      <div class="field col-3">
        <label class="block">To</label>
        <p-calendar [(ngModel)]="toDate" [showTime]="true" [style]="{'width':'100%'}" appendTo="body" showClear="true"
                    [minDate]="minSelectableDate" [maxDate]="maxSelectableDate"></p-calendar>
      </div>
      <div class="field col-2">
        <label class="block">&nbsp;</label>
        <p-button label="Draw" icon="pi pi-sync" iconPos="left"
                  [style]="{'width':'100%'}" (onClick)="drawLineGraph()"></p-button> <!--//(onClick)="drawLineGraph()"-->
      </div>
    </div>

    <br />

    <div id="graph"> </div>
  </div>
</div>
